export default __webpack_public_path__ + "static/media/republica-dominicana.7daedce0.svg";